import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M5.66667 8.00065H5.675M9 8.00065H9.00833M12.3333 8.00065H12.3417M16.5 8.00065C16.5 11.6825 13.1421 14.6673 9 14.6673C7.71728 14.6673 6.50976 14.3811 5.45389 13.8765L1.5 14.6673L2.66249 11.5673C1.9263 10.5359 1.5 9.31255 1.5 8.00065C1.5 4.31875 4.85786 1.33398 9 1.33398C13.1421 1.33398 16.5 4.31875 16.5 8.00065Z" />
  </svg>
);
